export const canvasClass = "paint__canvas";
